import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingKlingAiVideoGeneratorConfig } from '@/data/landingConfig/landingKlingAiVideoGeneratorConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_KlingAiVideoGenerator } from './schemaObject';

interface Props {}
const KlingAiVideoGenerator: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_KlingAiVideoGenerator} />
			<LandingTemplate
				data={landingKlingAiVideoGeneratorConfig}
				funnelLinkService={GenerateLandingLinkService.funnelTextToVideoV2()}
			/>
		</>
	);
};

export default KlingAiVideoGenerator;
